import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import ChatMessage from "./chatMessage";
import { UserChatHistoryList } from "../../services/user.service";
import { useParams } from "react-router-dom";

const ChatWindow = ({selectedFamily,familyMemberName}) => {
  const params = useParams();


  const userActivitySlice = useSelector((state) => state.userActivitySlice);
  const userDetailsSlice = useSelector((state) => state.userDetailsSlice);

  const [chatHistoryList, setChatHistoryList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);

  const chatContainerRef = useRef(null);

  const handleScroll = () => {
    const container = chatContainerRef.current;
    if (!container || loader || !hasMore) return;

    if (container.scrollTop <= 5) {
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    // if (!userDetailsSlice?.data?._id) return;
    if (!params.id) return;
    setChatHistoryList([]);
    setHasMore(true);
    setPage(1);
  }, [userActivitySlice?.activity?.month, userActivitySlice?.activity?.year, params.id]);

  useEffect(() => {
    // if (!userActivitySlice.activity || !userDetailsSlice?.data?._id) return;
    if (!params.id || !userActivitySlice.activity) return;

    setLoader(true);
    const formData = new FormData();
    // formData.append("_id", userDetailsSlice?.data?._id);
    formData.append("_id", params.id);
    formData.append("year", userActivitySlice.activity.year);
    formData.append("month", userActivitySlice.activity.month);
    formData.append("page", page);
    formData.append("family_member_id", selectedFamily);
    const container = chatContainerRef.current;
    const previousHeight = container?.scrollHeight || 0;

    UserChatHistoryList(formData)
      .then((data) => {
        if (!Array.isArray(data?.data?.list)) {
          setLoader(false);
          return;
        }

        const list = data.data.list;
        if (page === 1) {
          setChatHistoryList(list);
          setTimeout(() => {
            if (container) container.scrollTop = container.scrollHeight;
          }, 50);
        } else {
          setChatHistoryList((prev) => [...list.reverse(), ...prev]);
          setTimeout(() => {
            if (container) {
              const newHeight = container.scrollHeight;
              container.scrollTop = newHeight - previousHeight;
            }
          }, 50);
        }

        if (list.length === 0) setHasMore(false);
        setLoader(false);
      })
      .catch((err) => {
        console.log("Chat fetch error:", err);
        setLoader(false);
      });
  }, [page, userActivitySlice, userDetailsSlice?.data?._id,selectedFamily]);

  return (
    <div className="col-sm-12 col-md-12 col-lg-7 col-xl-8">
      <div className="card custom-card" style={{ backgroundColor: "#fff" }}>
        <div className="main-content-app pt-0">
          <div className="main-content-body main-content-body-chat">
            {/* Header */}
            <div className="main-chat-header pt-3">
              <div className="main-img-user online">
                <img src={userDetailsSlice?.data?.profile_image} alt="user" />
              </div>
              <div className="main-chat-msg-name">
              <h6>
                {selectedFamily && familyMemberName
                  ? familyMemberName
                  : userDetailsSlice?.data?.name}
              </h6>
              </div>
            </div>

            {/* Messages */}
            <div
              className="main-chat-body"
              ref={chatContainerRef}
              onScroll={handleScroll}
              style={{ overflowY: "auto", height:"auto" }}
            >
              <div className="content-inner">
                {!loader && chatHistoryList.length === 0 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "200px",
                        color: "#888",
                        fontWeight: "500",
                      }}
                    >
                      No Previous Chat History Found
                    </div>
                  )}

                {chatHistoryList.map((chat, index) => (
                  <React.Fragment key={index}>
                    <ChatMessage
                      message={chat?.user_query || ""}
                      createdAt={chat?.createdAt || ""}
                      reverse
                    />
                    <ChatMessage
                      message={chat?.chatbot_response || ""}
                      createdAt={chat?.createdAt || ""}
                    />
                  </React.Fragment>
                ))}

                {loader && (
                  <div style={{ textAlign: "center", padding: "10px" }}>
                    Loading...
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatWindow;
